/*

// Wait for 3 seconds after the document has fully loaded
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    // Find and remove the "undefined" text
    removeUndefinedText();

    // Wait for an additional 5 seconds and then check again
    setTimeout(function() {
      removeUndefinedText();
    }, 5000); // Wait for 5 seconds (5000 milliseconds)
  }, 3000); // Wait for 3 seconds (3000 milliseconds)
});

function removeUndefinedText() {
  // Find all elements containing the text "undefined"
  var elementsWithUndefined = document.querySelectorAll(':contains("undefined")');

  // Loop through the selected elements and remove the text
  elementsWithUndefined.forEach(function(element) {
    element.innerHTML = element.innerHTML.replace(/undefined/g, '');
  });
}

window.onload = function () {
      // Wait for the document to fully load before running the code
    document.addEventListener('DOMContentLoaded', function() {
      // Select all elements containing the text "undefined"
      var elementsWithUndefined = document.querySelectorAll(':contains("undefined")');
    
      // Loop through the selected elements and remove the text
      elementsWithUndefined.forEach(function(element) {
        element.textContent = element.textContent.replace(/undefined/g, '');
      });
    });
    if(document.querySelector('#slider-component .slider')){
        
        var elems = document.querySelectorAll('#slider-component .slider');
        elems.forEach(elem=>{
        var mediaQuery = window.matchMedia('(max-width: 767px)');
          if(mediaQuery.matches){
            var flkty = new Flickity( elem, {
            // options
            cellAlign: 'left',
            contain: true,
            pageDots: true,
            prevNextButtons: true,
            groupCells:true
            });
          }else{
            if(elem.querySelectorAll('.slider-item').length > 3){
                var flkty = new Flickity( elem, {
                // options
                cellAlign: 'left',
                contain: true,
                pageDots: true,
                prevNextButtons: true,
                  groupCells:true
                });
            }
          }
      })

    }
    if(document.querySelector('.dropdown-container')){
        document.querySelectorAll('.dropdown-container').forEach(item=>{
          item.addEventListener('click',function(e){
            item.classList.toggle('open');
          });
        })
    }
    if(document.querySelector('.menu-drawer__inner-container')){
        document.getElementById('ham').addEventListener('click',function(){
            document.querySelector('body').classList.toggle('open_drawer');
        })
    };

    // Create flickity to product images
    if(document.querySelector('.product-section .slider-container .slider')){
        var elem = document.querySelector('.product-section .slider-container .slider');
        var flkty = new Flickity( elem, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false
        });
    } 
    if(document.querySelector('.product-section .slider-container .customize-tools')){
        var elem = document.querySelector('.product-section .slider-container .customize-tools > .flex');
        var flkty = new Flickity( elem, {
        // options
        cellAlign: 'left',
        contain: true,
        asNavFor:".product-section .slider-container .slider",
        pageDots: false,
        prevNextButtons: false
        });

    }
    if(document.querySelector('.expert-slider')){
        var elem = document.querySelector('.expert-slider');
        var flkty = new Flickity( elem, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: false,
        autoPlay:2000
        });
    }
    var mediaQuery = window.matchMedia('(max-width: 767px)');
    if(mediaQuery.matches){
        if(document.querySelector('.logo-list_container')){
            var elem = document.querySelector('.logo-list_container');
            var flkty = new Flickity( elem, {
            // options
            cellAlign: 'left',
            contain: true,
            pageDots: true,
            prevNextButtons: false,
            autoPlay:2000
            });
        }
      


    }
}

*/

document.addEventListener('click', async (e) => {
  const addBtn = e.target.closest('[data-add-to-cart]');
  if (!addBtn) return;

  e.preventDefault();
  const form = addBtn.closest('form');
  const formData = new FormData(form);
  const cartDrawer = document.querySelector('cart-drawer');
  const drawerInner = cartDrawer?.querySelector('.drawer__inner');

  // ✅ Add button loading
  const originalText = addBtn.innerHTML;
  addBtn.classList.add('is-loading');
  addBtn.disabled = true;
  addBtn.innerHTML = `<span class="spinner"></span> Adding...`;

  // Check if cart is empty before adding
  const wasCartEmpty = drawerInner?.classList.contains('is-empty');

  try {
    // ✅ Open the drawer instantly
    if (cartDrawer) {
      cartDrawer.open();
      cartDrawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
    }

    // ✅ Show loading state only if cart was empty
    if (wasCartEmpty && drawerInner) {
      drawerInner.innerHTML = `
        <div class="cart-loading-state">
          <div class="spinner"></div>
          <p>Adding item to your cart...</p>
        </div>
      `;
    }

    // 1️⃣ Add to cart
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });

    if (!addResponse.ok) throw new Error('Failed to add to cart');

    // 2️⃣ Fetch updated sections
    const sectionsResponse = await fetch('/?sections=cart-drawer,cart-icon-bubble', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    const sections = await sectionsResponse.json();

    // 3️⃣ Render updated drawer content
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents({
        id: Date.now(),
        sections,
      });
    }

  } catch (err) {
    console.error('Error adding to cart:', err);
    if (drawerInner) {
      drawerInner.innerHTML = `<p class="text-center text-red-500 py-4">Something went wrong. Please try again.</p>`;
    }
  } finally {
    // ✅ Restore button state
    addBtn.classList.remove('is-loading');
    addBtn.disabled = false;
    addBtn.innerHTML = originalText;
  }
});

